module.exports = __webpack_public_path__ + "img/3.5da9ba8a.jpg";